import { getNiches } from "@/infrastructure/services/nicheService";
import { useCallback, useState } from "react";

export function useNiches() {
  const [nicheOptions, setNicheOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const clearNiches = useCallback(() => {
    setNicheOptions([]);
    setError("");
  }, []);
  const loadNiches = useCallback(async (categoryId: string) => {
    setIsLoading(true);
    setError("");
    try {
      const options = await getNiches(categoryId);
      setNicheOptions(options);
      return options;
    } catch (requestError) {
      const message =
        requestError instanceof Error
          ? requestError.message
          : "Não foi possível carregar as subcategorias.";
      setError(message);
      setNicheOptions([]);
      throw requestError;
    } finally {
      setIsLoading(false);
    }
  }, []);
  return { clearNiches, error, isLoading, loadNiches, nicheOptions };
}
